import { Component } from '@angular/core'

@Component({
  selector: 'atyl-row',
  templateUrl: './row.component.html',
  styleUrls: ['./row.component.scss']
})
export class RowComponent {

  constructor() { }

}
